import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import socialMediaData from "../information/socialmedia"
import MediaButton from "../components/MediaButton"

class Footer extends React.Component {
  render() {
    return (
      <div className="footer py-5">
        <Container>
          <Row>
            <Col className="text-center">
              <h5>Get in contact with me via</h5>
              {socialMediaData.map((media, index) => (
                <MediaButton key={index} item={media} />
              ))}
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <p className="copyright">
                © Copyright {new Date().getFullYear()} Sameeha Rahman
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Footer
